
const getRand = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min) + min);
}

const makeTests3 = () => {

    let arr = new Array(99).fill(0).map((val, ind) => { return ind+1 })

    let tests = [] as number[];

    while (tests.length < 6) {
        const rand = getRand(20, 99);
        if (!tests.includes(arr[rand])) {
            tests.push(arr[rand])
        }
    }

    while (tests.length >= 6 && tests.length < 26) {
        const rand = getRand(0, 99);
        if (!tests.includes(arr[rand])) {
            tests.push(arr[rand])
        }
    }

    const tests1 = tests.slice(0, 10)
    const tests2 = tests.slice(10, 16)
    const tests3 = tests.slice(16, 26)

    return [tests1, tests2, tests3];
}

export default makeTests3;